import React from "react";
import { SourcesDisplay } from "../../SourcesDisplay/SourcesDisplay";
import {
  AnswerContainer,
  SourcesContainer,
} from "./AnswerResponseDisplay.styles";

export const AnswerResponseDisplay = ({ data, t }) => {
  return (
    <div>
      <AnswerContainer>{data.answer}</AnswerContainer>
      {data.sources && (
        <SourcesContainer>
          <strong>{t("logs.sources")}:</strong>
          <SourcesDisplay sources={data.sources} t={t} />
        </SourcesContainer>
      )}
    </div>
  );
};
